export const extractId = (id: string): number => {
  return Number(id.split('-').at(-1)) || -1
}
